<div *ngIf="!isEmpty  && !isPrestationAssociees && !isFiliereDepartement" class="header">
  <div class="col-sm-6" style="padding: 0 15px;">
    <h2 *ngIf="personnel.id">
      Modification de : {{ personnel.nom || ''}} </h2>
    <h2 *ngIf="!personnel.id">
      Création {{societe.SI ? 'd\'un Partenaire' : 'd\'un Personnel'}}
    </h2>
  </div>
  <div class="col-sm-6 text-right" style="padding-right: 0;">
    <button class="btn-header uppercase" id="log" *ngIf="personnel.id && personnel.id > 0"
      (click)="common.getLogs(personnel.id, '16', modalService);">
      Log
    </button>
    <button class="btn-header uppercase" (click)="returnList()" id="close2">
      Fermer
    </button>
    <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
      Valider
    </button>
  </div>
</div>

<mat-divider *ngIf="!isEmpty && !isPrestationAssociees && !isFiliereDepartement"></mat-divider>

<div *ngIf="!isEmpty && !isPrestationAssociees && !isFiliereDepartement"
  class="paramsociete article restriction paramPersonel">
  <ngb-tabset>
    <ngb-tab>
      <ng-template ngbTabTitle> Général</ng-template>
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 0;">
          <div class="group1" style="padding-top: 10px;">
            <div class="form-group items col-sm-12" style="font-size: 10px;"> (
              <span style="color:red;">*</span> ) : Champs obligatoires
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp.persObj2 && common.visibleChamp.persObj2.visible">
              <label class="col-sm-3 champ" style="padding:0px">Civilité :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj4.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj2.creation) || (!add && edit && !common.visibleChamp.persObj2.modifiable)}">
                <app-autocomplete (searchfunction)="searchCivilite($event)"
                  (selectfunction)="personnel.civilite = $event" [results]="listCivilite" [highlight]="true"
                  [id]="'civilite'" [isCombo]="true" [defaultselected]="personnel.civilite" [disablefocus]="true"
                  [defaultsearch]="personnel.civilite ? personnel.civilite.libelle || personnel.civilite.libelleObjetEntite  : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp.persObj1 && common.visibleChamp.persObj1.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Nom <span class="champobligatoire"> * </span> :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control"  [hidden]="!common.visibleChamp.persObj1.vision"
                  [disabled]="(add && !common.visibleChamp.persObj1.creation) || (!add && edit && !common.visibleChamp.persObj1.modifiable)"
                  [(ngModel)]="personnel.nom">
              </div>
            </div>

            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp.persObj3  && (common.visibleChamp.persObj3.visible) ">
              <label class="col-sm-3 champ" style="padding:0px"> Prénom :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control"  [hidden]="!common.visibleChamp.persObj3.vision"
                  [disabled]="(add && !common.visibleChamp.persObj3.creation) || (!add && edit && !common.visibleChamp.persObj3.modifiable)"
                  [(ngModel)]="personnel.prenom">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp.persObj4  && (common.visibleChamp.persObj4.visible) ">
              <label class="col-sm-3 champ" style="padding:0px"> Date de naissance <span class="champobligatoire"> * </span> :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px"
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj4.creation) || (!add && edit && !common.visibleChamp.persObj4.modifiable)}">
                <!-- <input type="text" class="form-control" [(ngModel)]="personnel.dateNaissance" placeholder="dd/mm/aaaa"
                       (ngModelChange)="changeDateNaissance($event, 'dateNaissance')" maxlength="10"/> -->
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateNaissance" [maxDate]="dateMaxN"
                  [closeDatepickerOnSelect]="true"  [minDate]="dateMin"
                  *ngIf="common.visibleChamp.persObj4.vision" [showDatepicker]="true"
                  (changefct)="changeDateNaissance($event, 'dateNaissance')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj5  && (common.visibleChamp.persObj5.visible) ">
              <label class="col-sm-3 champ" style="padding:0px"> Téléphone fixe :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control"  [hidden]="!common.visibleChamp.persObj5.vision"
                  [disabled]="(add && !common.visibleChamp.persObj5.creation) || (!add && edit && !common.visibleChamp.persObj5.modifiable)"
                  [(ngModel)]="personnel.telFixe">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj6  && (common.visibleChamp.persObj6.visible) ">
              <label class="col-sm-3 champ" style="padding:0px">N° de portable pro. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control"  [hidden]="!common.visibleChamp.persObj6.vision"
                  [(ngModel)]="personnel.telPortableProfessionnel"
                  [disabled]="(add && !common.visibleChamp.persObj6.creation) || (!add && edit && !common.visibleChamp.persObj6.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj7  && (common.visibleChamp.persObj7.visible) ">
              <label class="col-sm-3 champ" style="padding:0px"> Fax :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.fax" 
                  [hidden]="!common.visibleChamp.persObj7.vision"
                  [disabled]="(add && !common.visibleChamp.persObj7.creation) || (!add && edit && !common.visibleChamp.persObj7.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj8  && (common.visibleChamp.persObj8.visible) ">
              <label class="col-sm-3 champ" style="padding:0px"> Mail :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.mail" 
                  [hidden]="!common.visibleChamp.persObj8.vision"
                  [disabled]="(add && !common.visibleChamp.persObj8.creation) || (!add && edit && !common.visibleChamp.persObj8.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  (common.visibleChamp.persObj9.visible || common.visibleChamp.persObj10.visible || common.visibleChamp.persObj10.visible) ">
              <label class="col-sm-3 champ" style="padding:0px">
                Adresse :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <div *ngIf='common.visibleChamp.persObj9.vision'
                  [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj9.creation) || (!add && edit && !common.visibleChamp.persObj9.modifiable)}">
                  <app-autocomplete *ngIf="adresseAutoBAK" [placeholder]="'Adresse'"
                    (searchfunction)="searchAdresseBAK($event)" (selectfunction)="setValueAdresseBAK($event)"
                    [results]="dataAdresseBAK" [container]="true"
                    [defaultsearch]="personnel.adresse1 ? personnel.adresse1 : ''" [minlength]="3"
                    [nePasCompterEspace]="true">
                  </app-autocomplete>
                </div>

                <div
                  *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj9  && (common.visibleChamp.persObj9.visible) ">
                  <input *ngIf="!adresseAutoBAK" type="text" class="form-control" [(ngModel)]="personnel.adresse1"
                    [readonly]="adresseAutoBAK"  [hidden]="!common.visibleChamp.persObj9.vision"
                    [disabled]="(add && !common.visibleChamp.persObj9.creation) || (!add && edit && !common.visibleChamp.persObj9.modifiable)">
                </div>
                <div
                  *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj10  && (common.visibleChamp.persObj10.visible)">
                  <input type="text" class="form-control" [(ngModel)]="personnel.adresse2" [readonly]="adresseAutoBAK"
                    style="margin-top: 5px; margin-bottom: 5px;" 
                    [hidden]="!common.visibleChamp.persObj10.vision"
                    [disabled]="(add && !common.visibleChamp.persObj10.creation) || (!add && edit && !common.visibleChamp.persObj10.modifiable)">
                </div>
                <div
                  *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj11  && (common.visibleChamp.persObj11.visible)">
                  <input type="text" class="form-control" [(ngModel)]="personnel.adresse3" [readonly]="adresseAutoBAK"
                    [hidden]="!common.visibleChamp.persObj11.vision"
                    [disabled]="(add && !common.visibleChamp.persObj11.creation) || (!add && edit && !common.visibleChamp.persObj11.modifiable)">
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj12  && common.visibleChamp.persObj12.visible">
              <label class="col-sm-3 champ" style="padding:0px">
                Code Postal :
              </label>
              <div class="col-sm-9 champ" *ngIf='common.visibleChamp.persObj12.vision' style="padding-right: 0px"
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj12.creation) || (!add && edit && !common.visibleChamp.persObj12.modifiable)}">
                <app-autocomplete-cp-ville [cp]="'codePostal'" [item]="personnel" [ville]="'ville'" [iscp]="true"
                  [disable]="adresseAutoBAK">
                </app-autocomplete-cp-ville>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp &&  common.visibleChamp.persObj13  && common.visibleChamp.persObj13.visible">
              <label class="col-sm-3 champ" style="padding:0px">
                Ville :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj13.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj13.creation) || (!add && edit && !common.visibleChamp.persObj13.modifiable)}">
                <app-autocomplete-cp-ville [cp]="'codePostal'" [item]="personnel" [ville]="'ville'"
                  [disable]="adresseAutoBAK"></app-autocomplete-cp-ville>
              </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="adresseAutoBAK">
              <label class="col-sm-3 champ" style="padding:0px">
                Ancienne Ville :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <div *ngIf="!edit"> {{common.bak.ancienneVille}} </div>
                <div *ngIf="edit">
                  <app-autocomplete-cp-ville [item]="common.bak" [ville]="'ancienneVille'" [disable]="adresseAutoBAK">
                  </app-autocomplete-cp-ville>
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf=" common.visibleChamp.persObj14  && (common.visibleChamp.persObj14.visible) ">
              <label class="col-sm-3 champ" style="padding:0px">Couleur :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <!-- <input type="text" class="form-control" [(ngModel)]="personnel.couleur"> -->

                <input class="form-control " *ngIf="!visionCouleur" type="text" id="exampleInputEmail1"
                  [(ngModel)]="personnel.couleur" (ngModelChange)="onChangeColorPrs($event, personnel)"
                  [ngStyle]="{'border-left': borderColorPrs(personnel)}" [popover]="popTemplateUser" placement="auto"
                  [outsideClick]="true" style="width: 300px"  [hidden]="!visionCouleur"
                  [disabled]="(add && !common.visibleChamp.persObj14.creation) || (!add && edit && !common.visibleChamp.persObj14.modifiable)" />
                <input class="form-control " *ngIf="visionCouleur" type="text" id="exampleInputEmail1"
                  [(ngModel)]="personnel.couleur" (ngModelChange)="onChangeColorPrs($event, personnel)"
                  [ngStyle]="{'border-left': borderColorPrs(personnel)}" [popover]="popTemplateUser" placement="auto"
                  [outsideClick]="true" style="width: 300px"
                  [disabled]="(add && !common.visibleChamp.persObj14.creation) || (!add && edit && !common.visibleChamp.persObj14.modifiable)" />
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj15 && common.visibleChamp.persObj15.visible">
              <label class="col-sm-3 champ" style="padding:0px">Materiel : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj15.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj15.creation) || (!add && edit && !common.visibleChamp.persObj15.modifiable)}">
                <!--(selectfunction)="setCamion($event)"-->
                <app-autocomplete [placeholder]="''" (searchfunction)="searchCamion($event)" [showonclick]="true"
                  (selectfunction)="selectMateriel($event)" [results]="dataCamion" [highlight]="true" [label]="''"
                  [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'" [defaultselected]="personnel.camion"
                  (clearfunction)="personnel.camion = {id: 0}"
                  [defaultsearch]="personnel.camion && personnel.camion.id ? (( personnel.camion.numParc ? personnel.camion.numParc +'/'+ personnel.camion.immatriculation :personnel.camion.immatriculation) || personnel.camion.libelleObjetEntite || '') : 'Aucun'"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj16  && common.visibleChamp.persObj16.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Zone : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj16.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj16.creation) || (!add && edit && !common.visibleChamp.persObj16.modifiable)}">
                <app-autocomplete (selectfunction)="personnel.zone = $event" [results]="resultZone" [highlight]="true"
                  [id]="'modedepaie clientRefact'" [isCombo]="true" [defaultselected]="personnel.zone"
                  [defaultsearch]="personnel.zone ? personnel.zone.libelle : ''">
                </app-autocomplete>
              </div>
            </div>
            <!--div class="form-group items col-sm-12" *ngIf="personnel.camion && personnel.camion.id">
              <label class="col-sm-3 champ" style="padding:0px">Materiel : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ personnel.camion ? personnel.camion.immatriculation : '' }}
              </div>
            </div-->
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Qualification">
      <ng-template ngbTabContent>
        <div style="padding-top: 10px;">
          <div class="group1" style="padding-top: 10px;">
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj18  && common.visibleChamp.persObj18.visible">
              <label class="col-sm-3 champ" style="padding:0px">Numero de permis :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.numeroPermis" 
                  [hidden]="!common.visibleChamp.persObj18.vision"
                  [disabled]="(add && !common.visibleChamp.persObj18.creation) || (!add && edit && !common.visibleChamp.persObj18.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj19  && common.visibleChamp.persObj19.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Permis VL :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj19.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.permisVL"
                  [disabled]="(add && !common.visibleChamp.persObj19.creation) || (!add && edit && !common.visibleChamp.persObj19.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj20  && common.visibleChamp.persObj20.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date expiration permis VL :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.validitePermis" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'validitePermis')" 
                  *ngIf="common.visibleChamp.persObj20.vision"
                  [disable]="!personnel.permisVL &&  ((add && !common.visibleChamp.persObj20.creation) || (!add && edit && !common.visibleChamp.persObj20.modifiable))"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj21  && common.visibleChamp.persObj21.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Permis PL :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj21.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.permisPL"
                  [disabled]="(add && !common.visibleChamp.persObj21.creation) || (!add && edit && !common.visibleChamp.persObj21.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj22  && common.visibleChamp.persObj22.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date expiration permis PL :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateExpirationPermisPL" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'dateExpirationPermisPL')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj22.vision"
                  [disable]="!personnel.permisPL && ((add && !common.visibleChamp.persObj22.creation) || (!add && edit && !common.visibleChamp.persObj22.modifiable)) "></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj23  && common.visibleChamp.persObj23.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Permis SPL :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj23.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.permisSPL"
                  [disabled]="(add && !common.visibleChamp.persObj23.creation) || (!add && edit && !common.visibleChamp.persObj23.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj24  && common.visibleChamp.persObj24.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date expiration permis SPL :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateExpirationPermisSPL" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'dateExpirationPermisSPL')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj24.vision"
                  [disable]="!personnel.permisSPL && ((add && !common.visibleChamp.persObj24.creation) || (!add && edit && !common.visibleChamp.persObj24.modifiable)) "></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj25  && common.visibleChamp.persObj25.visible">
              <label class="col-sm-3 champ" style="padding:0px"> FIMO :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj25.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.FIMO"
                  [disabled]="(add && !common.visibleChamp.persObj25.creation) || (!add && edit && !common.visibleChamp.persObj25.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj26  && common.visibleChamp.persObj26.visible">
              <label class="col-sm-3 champ" style="padding:0px"> FIMO (JJ/MM/AAAA) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.fimo" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'fimo')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj26.vision"
                  [disable]="!personnel.FIMO && ((add && !common.visibleChamp.persObj26.creation) || (!add && edit && !common.visibleChamp.persObj26.modifiable))"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj28  && common.visibleChamp.persObj28.visible">
              <label class="col-sm-3 champ" style="padding:0px"> FCOS :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj28.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.FCOS"
                  [disabled]="(add && !common.visibleChamp.persObj28.creation) || (!add && edit && !common.visibleChamp.persObj28.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj29  && common.visibleChamp.persObj29.visible">
              <label class="col-sm-3 champ" style="padding:0px"> FCOS (JJ/MM/AAAA) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.fcos" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'fcos')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj29.vision"
                  [disable]="!personnel.FCOS && (add && !common.visibleChamp.persObj29.creation) || (!add && edit && !common.visibleChamp.persObj29.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj30  && common.visibleChamp.persObj30.visible">
              <label class="col-sm-3 champ" style="padding:0px">APTH (JJ/MM/AAAA) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.apth" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'apth')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj30.vision"
                  [disable]="(add && !common.visibleChamp.persObj30.creation) || (!add && edit && !common.visibleChamp.persObj30.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj31  && common.visibleChamp.persObj31.visible">
              <label class="col-sm-3 champ" style="padding:0px"> ADR :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj31.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.ADR"
                  [disabled]="(add && !common.visibleChamp.persObj31.creation) || (!add && edit && !common.visibleChamp.persObj31.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj32  && common.visibleChamp.persObj32.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date de validité ADR :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateADR" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'dateADR')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj32.vision"
                  [disable]="!personnel.ADR && ((add && !common.visibleChamp.persObj32.creation) || (!add && edit && !common.visibleChamp.persObj32.modifiable))">
                </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj33  && common.visibleChamp.persObj33.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date der. visite médicale :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateDerniereVisiteMedicale" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj33.vision"
                  [disable]="(add && !common.visibleChamp.persObj33.creation) || (!add && edit && !common.visibleChamp.persObj33.modifiable)"
                  (changefct)="changeDate($event, 'dateDerniereVisiteMedicale')">
                </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date validité visite médicale :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateValiditeVisiteMedicale" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')">
                </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj34  && common.visibleChamp.persObj34.visible">
              <label class="col-sm-3 champ" style="padding:0px"> UICPR1 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.UICPR1" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" [visibleCondition]="true" [condition]="common.visibleChamp.persObj34.vision"
                  [disable]="(add && !common.visibleChamp.persObj34.creation) || (!add && edit && !common.visibleChamp.persObj34.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"
                  (changefct)="changeDate($event, 'UICPR1')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj35  && common.visibleChamp.persObj35.visible">
              <label class="col-sm-3 champ" style="padding:0px"> UICPR2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.UICPR2" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" [visibleCondition]="true" [condition]="common.visibleChamp.persObj35.vision"
                  [disable]="(add && !common.visibleChamp.persObj35.creation) || (!add && edit && !common.visibleChamp.persObj35.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"
                  (changefct)="changeDate($event, 'UICPR2')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj36  && common.visibleChamp.persObj36.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 1 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES1" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" [visibleCondition]="true" [condition]="common.visibleChamp.persObj36.vision"
                  [disable]="(add && !common.visibleChamp.persObj36.creation) || (!add && edit && !common.visibleChamp.persObj36.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"
                  (changefct)="changeDate($event, 'CACES1')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj37  && common.visibleChamp.persObj37.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES2" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES2')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj37.vision"
                  [disable]="(add && !common.visibleChamp.persObj37.creation) || (!add && edit && !common.visibleChamp.persObj37.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj38  && common.visibleChamp.persObj38.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 3 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES3" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES3')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj38.vision"
                  [disable]="(add && !common.visibleChamp.persObj38.creation) || (!add && edit && !common.visibleChamp.persObj38.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj39  && common.visibleChamp.persObj39.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 4 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES4" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES4')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj39.vision"
                  [disable]="(add && !common.visibleChamp.persObj39.creation) || (!add && edit && !common.visibleChamp.persObj39.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj40  && common.visibleChamp.persObj40.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 5 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES5" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES5')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj40.vision"
                  [disable]="(add && !common.visibleChamp.persObj40.creation) || (!add && edit && !common.visibleChamp.persObj40.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj41  && common.visibleChamp.persObj41.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 6 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES6" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES6')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj41.vision"
                  [disable]="(add && !common.visibleChamp.persObj41.creation) || (!add && edit && !common.visibleChamp.persObj41.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj42  && common.visibleChamp.persObj42.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 7 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES7" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES7')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj42.vision"
                  [disable]="(add && !common.visibleChamp.persObj42.creation) || (!add && edit && !common.visibleChamp.persObj42.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj43  && common.visibleChamp.persObj43.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 8 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES8" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES8')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj43.vision"
                  [disable]="(add && !common.visibleChamp.persObj43.creation) || (!add && edit && !common.visibleChamp.persObj43.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj44  && common.visibleChamp.persObj44.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 9 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES9" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES9')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj44.vision"
                  [disable]="(add && !common.visibleChamp.persObj44.creation) || (!add && edit && !common.visibleChamp.persObj44.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj45  && common.visibleChamp.persObj45.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Engin de chantier 10 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACES10" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACES10')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj45.vision"
                  [disable]="(add && !common.visibleChamp.persObj45.creation) || (!add && edit && !common.visibleChamp.persObj45.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj46  && common.visibleChamp.persObj46.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue à tour GMA Cabine :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourGMACabine" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourGMACabine')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj46.vision"
                  [disable]="(add && !common.visibleChamp.persObj46.creation) || (!add && edit && !common.visibleChamp.persObj46.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj47  && common.visibleChamp.persObj47.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue à tour GME :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourGME" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourGME')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj47.vision"
                  [disable]="(add && !common.visibleChamp.persObj47.creation) || (!add && edit && !common.visibleChamp.persObj47.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj48  && common.visibleChamp.persObj48.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue à tour relevable :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourRelevable" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourRelevable')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj48.vision"
                  [disable]="(add && !common.visibleChamp.persObj48.creation) || (!add && edit && !common.visibleChamp.persObj48.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj49  && common.visibleChamp.persObj49.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue à tour GMA sol :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourGMASol" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourGMASol')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj49.vision"
                  [disable]="(add && !common.visibleChamp.persObj49.creation) || (!add && edit && !common.visibleChamp.persObj49.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj50  && common.visibleChamp.persObj50.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue mobile 1A :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourMobile1A" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourMobile1A')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj50.vision"
                  [disable]="(add && !common.visibleChamp.persObj50.creation) || (!add && edit && !common.visibleChamp.persObj50.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj51  && common.visibleChamp.persObj51.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue mobile 1B :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourMobile1B" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourMobile1B')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj51.vision"
                  [disable]="(add && !common.visibleChamp.persObj51.creation) || (!add && edit && !common.visibleChamp.persObj51.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj52  && common.visibleChamp.persObj52.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue mobile 2A :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourMobile2A" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourMobile2A')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj52.vision"
                  [disable]="(add && !common.visibleChamp.persObj52.creation) || (!add && edit && !common.visibleChamp.persObj52.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj53  && common.visibleChamp.persObj53.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue mobile 2B :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourMobile2B" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourMobile2B')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj53.vision"
                  [disable]="(add && !common.visibleChamp.persObj53.creation) || (!add && edit && !common.visibleChamp.persObj53.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj54  && common.visibleChamp.persObj54.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue mobile 2C :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueTourMobile2C" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESGrueTourMobile2C')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj54.vision"
                  [disable]="(add && !common.visibleChamp.persObj54.creation) || (!add && edit && !common.visibleChamp.persObj54.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj55 && common.visibleChamp.persObj55.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES élev. pers. 1A :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESMobilePersonnel1A" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESMobilePersonnel1A')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj55.vision"
                  [disable]="(add && !common.visibleChamp.persObj55.creation) || (!add && edit && !common.visibleChamp.persObj55.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj56 && common.visibleChamp.persObj56.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES élev. pers. 1B :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESMobilePersonnel1B" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESMobilePersonnel1B')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj56.vision"
                  [disable]="(add && !common.visibleChamp.persObj56.creation) || (!add && edit && !common.visibleChamp.persObj56.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj57 && common.visibleChamp.persObj57.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES élev. pers. 2A :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESMobilePersonnel2A" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESMobilePersonnel2A')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj57.vision"
                  [disable]="(add && !common.visibleChamp.persObj57.creation) || (!add && edit && !common.visibleChamp.persObj57.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj58 && common.visibleChamp.persObj58.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES élev. pers. 2B :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESMobilePersonnel2B" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESMobilePersonnel2B')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj58.vision"
                  [disable]="(add && !common.visibleChamp.persObj58.creation) || (!add && edit && !common.visibleChamp.persObj58.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj59 && common.visibleChamp.persObj59.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES élev. pers. 3A :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESMobilePersonnel3A" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESMobilePersonnel3A')"
                  [disable]="(add && !common.visibleChamp.persObj59.creation) || (!add && edit && !common.visibleChamp.persObj59.modifiable)"
                  [visibleCondition]="true" [condition]="common.visibleChamp.persObj59.vision"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj60 && common.visibleChamp.persObj60.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES élev. pers. 3B :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESMobilePersonnel3B" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESMobilePersonnel3B')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj60.vision"
                  [disable]="(add && !common.visibleChamp.persObj60.creation) || (!add && edit && !common.visibleChamp.persObj60.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj61 && common.visibleChamp.persObj61.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Chariot manut. cond.1 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESManutConduct1" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESManutConduct1')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj61.vision"
                  [disable]="(add && !common.visibleChamp.persObj61.creation) || (!add && edit && !common.visibleChamp.persObj61.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj62 && common.visibleChamp.persObj62.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Chariot manut. cond.2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESManutConduct2" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESManutConduct2')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj62.vision"
                  [disable]="(add && !common.visibleChamp.persObj62.creation) || (!add && edit && !common.visibleChamp.persObj62.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj63 && common.visibleChamp.persObj63.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Chariot manut. cond.3 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESManutConduct3" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESManutConduct3')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj63.vision"
                  [disable]="(add && !common.visibleChamp.persObj63.creation) || (!add && edit && !common.visibleChamp.persObj63.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj64 && common.visibleChamp.persObj64.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Chariot manut. cond.4 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESManutConduct4" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESManutConduct4')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj64.vision"
                  [disable]="(add && !common.visibleChamp.persObj64.creation) || (!add && edit && !common.visibleChamp.persObj64.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj65 && common.visibleChamp.persObj65.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Chariot manut. cond.5 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESManutConduct5" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESManutConduct5')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj65.vision"
                  [disable]="(add && !common.visibleChamp.persObj65.creation) || (!add && edit && !common.visibleChamp.persObj65.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj66 && common.visibleChamp.persObj66.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Chariot manut. cond.6 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESManutConduct6" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'CACESManutConduct6')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj66.vision"
                  [disable]="(add && !common.visibleChamp.persObj66.creation) || (!add && edit && !common.visibleChamp.persObj66.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj67 && common.visibleChamp.persObj67.visible">
              <label class="col-sm-3 champ" style="padding:0px"> CACES Grue auxiliaire :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.CACESGrueAux" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'CACESGrueAux')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj67.vision"
                  [disable]="(add && !common.visibleChamp.persObj67.creation) || (!add && edit && !common.visibleChamp.persObj67.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj68 && common.visibleChamp.persObj68.visible">
              <label class="col-sm-3 champ" style="padding:0px"> SST (Sauveteur Secouriste du travail) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.SST" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'SST')" [visibleCondition]="true"
                  [position]="'top-left'" [condition]="common.visibleChamp.persObj68.vision"
                  [disable]="(add && !common.visibleChamp.persObj68.creation) || (!add && edit && !common.visibleChamp.persObj68.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj69 && common.visibleChamp.persObj69.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Form. contre incendie et l'evac. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.formationIncendie" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'formationIncendie')" [position]="'top-left'"
                  [visibleCondition]="true" [condition]="common.visibleChamp.persObj69.vision"
                  [disable]="(add && !common.visibleChamp.persObj69.creation) || (!add && edit && !common.visibleChamp.persObj69.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj70 && common.visibleChamp.persObj70.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Form. Risques Biologiques :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.formationRisqueBio" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'formationRisqueBio')" [position]="'top-left'"
                  [visibleCondition]="true" [condition]="common.visibleChamp.persObj70.vision"
                  [disable]="(add && !common.visibleChamp.persObj70.creation) || (!add && edit && !common.visibleChamp.persObj70.modifiable)">
                </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj71 && common.visibleChamp.persObj71.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Amiante :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <!-- <input type="text" class="form-control" [(ngModel)]="personnel.amiante"> -->
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.amiante" [maxDate]="maxDate" [closeDatepickerOnSelect]="true"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'amiante')" [visibleCondition]="true"
                  [condition]="common.visibleChamp.persObj71.vision" [position]="'top-left'"
                  [disable]="(add && !common.visibleChamp.persObj71.creation) || (!add && edit && !common.visibleChamp.persObj71.modifiable)"></app-input-date>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="RH">
      <ng-template ngbTabContent>
        <div style="padding-top: 10px;">
          <div class="group1" style="padding-top: 10px;">
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj72  && common.visibleChamp.persObj72.visible">
              <label class="col-sm-3 champ" style="padding:0px">Matricule :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.matricule" 
                  [hidden]="!common.visibleChamp.persObj72.vision"
                  [disabled]="personnel.interimaire && isMatriculeAutoInterimaire && ((add && !common.visibleChamp.persObj72.creation) || (!add && edit && !common.visibleChamp.persObj72.modifiable))">
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">Chef d'équipe :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" (searchfunction)="searchChauffeur($event)"
                  (selectfunction)="personnel.chauffeurChef = $event;" [results]="listChauffeur" [highlight]="true"
                  [label]="''" [dropdownclass]="mindropdown" [id]="'modedepaie equipe '"
                  [defaultselected]="personnel.chauffeurChef && personnel.chauffeurChef.id ? (personnel.chauffeurChef.libelleObjetEntite || ((personnel.chauffeurChef.prenom || '') +' '+ personnel.chauffeurChef.nom)) : 'Non définis'"
                  [defaultsearch]="personnel.chauffeurChef && personnel.chauffeurChef.id ? (personnel.chauffeurChef.libelleObjetEntite || ((personnel.chauffeurChef.prenom || '') +' '+ personnel.chauffeurChef.nom)) : 'Non définis'"></app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj73  && common.visibleChamp.persObj73.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Activité de la société :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj73.vision'>
                <app-autocomplete (searchfunction)="searchActiviteSociete($event)"
                  (selectfunction)="personnel.activiteSociete = $event" [results]="listActiviteSociete"
                  [highlight]="true" [id]="'activiteSociete'" [isCombo]="true"
                  [defaultselected]="personnel.activiteSociete" [disablefocus]="true"
                  [isDisabled]="(add && !common.visibleChamp.persObj73.creation) || (!add && edit && !common.visibleChamp.persObj73.modifiable)"
                  (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"
                  [defaultsearch]="personnel.activiteSociete ? personnel.activiteSociete.libelle || personnel.activiteSociete.libelleObjetEntite  : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj74  && common.visibleChamp.persObj74.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Type de contrat :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': isInterim }"
                *ngIf='common.visibleChamp.persObj74.vision'>
                <app-autocomplete (selectfunction)="personnel.typeContratPersonnel = $event" [results]="listTypeContrat"
                  [highlight]="true" [id]="'activiteSociete'" [isCombo]="true"
                  [defaultselected]="personnel.typeContratPersonnel" [disablefocus]="true"
                  [isDisabled]="(add && !common.visibleChamp.persObj74.creation) || (!add && edit && !common.visibleChamp.persObj74.modifiable)"
                  [defaultsearch]="personnel.typeContratPersonnel ? personnel.typeContratPersonnel.libelle || personnel.typeContratPersonnel.libelleObjetEntite  : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj75  && common.visibleChamp.persObj75.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Intérimaire :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px"
                [ngClass]="{'disabledbutton': isInterim && ((add && !common.visibleChamp.persObj75.creation) || (!add && edit && !common.visibleChamp.persObj75.modifiable))}"
                *ngIf='common.visibleChamp.persObj75.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.interimaire"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj76  && common.visibleChamp.persObj76.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Facturation :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px"
                [ngClass]="{'disabledbutton': !personnel.interimaire}" *ngIf='common.visibleChamp.persObj76.vision'>
                <app-autocomplete (searchfunction)="searchFacturationInterim($event)"
                  (selectfunction)="personnel.facturationInterim = $event" [results]="listFacturation"
                  [highlight]="true" [id]="'activiteSociete'" [isCombo]="true"
                  [isDisabled]="(add && !common.visibleChamp.persObj76.creation) || (!add && edit && !common.visibleChamp.persObj76.modifiable)"
                  [defaultselected]="personnel.facturationInterim" [disablefocus]="true"
                  [defaultsearch]="personnel.facturationInterim ? personnel.facturationInterim.libelle || personnel.facturationInterim.libelleObjetEntite  : ''"
                  [active]="!personnel.interimaire"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj77  && common.visibleChamp.persObj77.visible">
              <label class="col-sm-3 champ" style="padding:0px">Agence : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px"
                [ngClass]="{'disabledbutton': !personnel.interimaire && ((add && !common.visibleChamp.persObj77.creation) || (!add && edit && !common.visibleChamp.persObj77.modifiable) )}"
                *ngIf='common.visibleChamp.persObj77.vision && personnel.interimaire'>
                <app-autocomplete [placeholder]="''" (searchfunction)="searchAgence($event)"
                  (selectfunction)="setAgence($event)" [results]="dataAgence" [highlight]="true" [label]="''"
                  [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'" [active]="!personnel.interimaire"
                  [defaultselected]="personnel.agenceInterim"
                  [defaultsearch]="personnel.agenceInterim ? ((personnel.agenceInterim.codeAgence || '') + ' / ' + (personnel.agenceInterim.nom || '')) : ''">
                </app-autocomplete>
              </div>

              <div class="col-sm-9 champ" style="padding-right: 0px"
              [ngClass]="{'disabledbutton': !personnel.interimaire && ((add && !common.visibleChamp.persObj77.creation) || (!add && edit && !common.visibleChamp.persObj77.modifiable) )}"
              *ngIf='common.visibleChamp.persObj77.vision && !personnel.interimaire'>
               <div class="form-control" style="height: 35px;background-color: #eeeeee;font-size: 12px">
                   {{ personnel.agenceInterim ? ((personnel.agenceInterim.codeAgence || '') + ' / ' + (personnel.agenceInterim.nom || '')) : ''}}
               </div>
            </div>

            </div>
            <!--div class="form-group items col-sm-12" *ngIf="personnel.agenceInterim && personnel.agenceInterim.id">
              <label class="col-sm-3 champ" style="padding:0px">Agence : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ personnel.agenceInterim && personnel.agenceInterim.codeAgence && personnel.agenceInterim.nom ? personnel.agenceInterim.codeAgence + "/" : '' }}
                {{ personnel.agenceInterim ? personnel.agenceInterim.nom : '' }}
              </div>
            </div-->
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj80  && common.visibleChamp.persObj80.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Modulation :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj80.vision'>
                <app-autocomplete (selectfunction)="personnel.modulationPersonnel = $event" [results]="listModulation"
                  [highlight]="true" [id]="'modulationPersonnel'" [isCombo]="true"
                  [defaultselected]="personnel.modulationPersonnel" [disablefocus]="true"
                  [isDisabled]="(add && !common.visibleChamp.persObj80.creation) || (!add && edit && !common.visibleChamp.persObj80.modifiable)"
                  [defaultsearch]="personnel.modulationPersonnel ? personnel.modulationPersonnel.libelle || personnel.modulationPersonnel.libelleObjetEntite  : ''"
                  ></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj81  && common.visibleChamp.persObj81.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Travail Sem. Partielle :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj81.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.semainePartielle"
                  [disabled]="(add && !common.visibleChamp.persObj81.creation) || (!add && edit && !common.visibleChamp.persObj81.modifiable)">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="personnel.semainePartielle">
              <label class="col-sm-3 champ" style="padding:0px"></label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <div class="col-sm-9 champ text-underline historique" (click)="showJourTravailler()">
                  Jours travaillés
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj82  && common.visibleChamp.persObj82.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Heure début :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.heureDebut"
                  [disabled]="(add && !common.visibleChamp.persObj82.creation) || (!add && edit && !common.visibleChamp.persObj82.modifiable)"
                  (blur)='refactorHeureDebut()'  [hidden]="!common.visibleChamp.persObj82.vision">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj83  && common.visibleChamp.persObj83.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Heure fin :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.heureFin" (blur)='refactorHeureFin()'
                  [disabled]="(add && !common.visibleChamp.persObj83.creation) || (!add && edit && !common.visibleChamp.persObj83.modifiable)"
                  [hidden]="!common.visibleChamp.persObj83.vision">
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Nationalité française :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.isFrancais">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj84  && common.visibleChamp.persObj84.visible">
              <label class="col-sm-3 champ" style="padding:0px"> N° de carte de séjour :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.numCarteSejour" 
                  [hidden]="!common.visibleChamp.persObj84.vision"
                  [disabled]="(add && !common.visibleChamp.persObj84.creation) || (!add && edit && !common.visibleChamp.persObj84.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj85  && common.visibleChamp.persObj85.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date d'exp. de la carte de sejour :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateExpirationCarteSejour" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" [showDatepicker]="true"
                  (changefct)="changeDate($event, 'dateExpirationCarteSejour')" 
                  *ngIf="common.visibleChamp.persObj85.vision"
                  [disable]="(add && !common.visibleChamp.persObj85.creation) || (!add && edit && !common.visibleChamp.persObj85.modifiable)">
                </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj86  && common.visibleChamp.persObj86.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Visible dans les plannings :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj86.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.visiblePlanning"
                  [disabled]="(add && !common.visibleChamp.persObj86.creation) || (!add && edit && !common.visibleChamp.persObj86.modifiable)">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj87  && common.visibleChamp.persObj87.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Compteur CP :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" class="form-control" [(ngModel)]="personnel.compteurCP"
                  [disabled]="(add && !common.visibleChamp.persObj87.creation) || (!add && edit && !common.visibleChamp.persObj87.modifiable)"
                  [hidden]="!common.visibleChamp.persObj87.vision">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj88  && common.visibleChamp.persObj88.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Compteur RTT :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" class="form-control" [(ngModel)]="personnel.compteurRTT"
                  [disabled]="(add && !common.visibleChamp.persObj88.creation) || (!add && edit && !common.visibleChamp.persObj88.modifiable)"
                  [hidden]="!common.visibleChamp.persObj88.vision">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj89  && common.visibleChamp.persObj89.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Compteur H Supp 25% :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" class="form-control" [(ngModel)]="personnel.compteurHSupp25" 
                  [hidden]="!common.visibleChamp.persObj89.vision"
                  [disabled]="(add && !common.visibleChamp.persObj89.creation) || (!add && edit && !common.visibleChamp.persObj89.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj90  && common.visibleChamp.persObj90.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Compteur H Supp 50% :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" class="form-control" [(ngModel)]="personnel.compteurHSupp50" 
                  [hidden]="!common.visibleChamp.persObj90.vision"
                  [disabled]="(add && !common.visibleChamp.persObj90.creation) || (!add && edit && !common.visibleChamp.persObj90.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Restrictions médicales :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <textarea class="form-control" [(ngModel)]="personnel.restrictionMedicale" rows="3"
                  style="height: 80px;"></textarea>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Divers">
      <ng-template ngbTabContent>
        <div style="padding-top: 10px;">
          <div class="group1" style="padding-top: 10px;">
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj91  && common.visibleChamp.persObj91.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Sous traitant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj91.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.isSsTraitant"
                  [disabled]="(add && !common.visibleChamp.persObj91.creation) || (!add && edit && !common.visibleChamp.persObj91.modifiable)">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj92  && common.visibleChamp.persObj92.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Sous traitant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj92.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj92.creation) || (!add && edit && !common.visibleChamp.persObj92.modifiable)}">
                <app-autocomplete [placeholder]="''" (searchfunction)="dataSousTraitant=[];searchSousTraitant($event)"
                  (selectfunction)="setSousTraitant($event)" [results]="dataSousTraitant" [autoshow]="true"
                  [highlight]="true" [label]="''" [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'"
                  [active]="!personnel.isSsTraitant" [notShowOnInit]="true" [defaultselected]="personnel.employeur"
                  [defaultsearch]="personnel.employeur ? ((personnel.employeur.codeClient || '') + ((personnel.employeur.id && personnel.employeur.id !==0)?'/': 'Aucun')  + (personnel.employeur.nomClient || ''))  : 'Aucun'"></app-autocomplete>
              </div>
            </div>
            <!--div class="form-group items col-sm-12" *ngIf="personnel.employeur && personnel.employeur.id">
              <label class="col-sm-3 champ" style="padding:0px">Nom du sous traitant : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ personnel.employeur && personnel.employeur.codeClient ? personnel.employeur.codeClient + "/" : '' }}
                {{ personnel.employeur ? personnel.employeur.nomClient : '' }}
              </div>
            </div-->

            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj93  && common.visibleChamp.persObj93.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Transporteur :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj93.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj93.creation) || (!add && edit && !common.visibleChamp.persObj93.modifiable)}">
                <app-autocomplete [placeholder]="''" (searchfunction)="searchTransporteur($event)"
                  (selectfunction)="personnel.transporteur = $event" [results]="dataTransporteur" [highlight]="true"
                  [showonclick]="true" [label]="''" [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'"
                  [active]="!personnel.isSsTraitant" [defaultselected]="personnel.transporteur"
                  [defaultsearch]="personnel.transporteur ? (personnel.transporteur.nom || personnel.transporteur.libelleObjetEntite || 'Aucun') : 'Aucun'"></app-autocomplete>
              </div>
            </div>
            <!--div class="form-group items col-sm-12" *ngIf="personnel.transporteur && personnel.transporteur.id">
              <label class="col-sm-3 champ" style="padding:0px">Nom du transporteur : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ personnel.transporteur ? personnel.transporteur.nom : '' }}
              </div>
            </div-->
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj94  && common.visibleChamp.persObj94.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Code Analytique :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.codeAnalytique" 
                  [hidden]="!common.visibleChamp.persObj94.vision"
                  [disabled]="(add && !common.visibleChamp.persObj94.creation) || (!add && edit && !common.visibleChamp.persObj94.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj95  && common.visibleChamp.persObj95.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Code Analytique Achat :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.codeAnalytiqueAchat" 
                  [hidden]="!common.visibleChamp.persObj95.vision"
                  [disabled]="(add && !common.visibleChamp.persObj95.creation) || (!add && edit && !common.visibleChamp.persObj95.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj96  && common.visibleChamp.persObj96.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Prestations associée... :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj96.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj96.creation) || (!add && edit && !common.visibleChamp.persObj96.modifiable)}">
                <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px"
                  (click)="showPrestationAssociees()">
                  Définir
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj3  && common.visibleChamp.persObj97.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Filières/Département :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj97.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj97.creation) || (!add && edit && !common.visibleChamp.persObj97.modifiable)}">
                <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px"
                  (click)="showFiliereDepartement()">
                  Définir
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj98  && common.visibleChamp.persObj98.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Code partenaire :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.codeEcorecExterne" 
                  [hidden]="!common.visibleChamp.persObj98.vision"
                  [disabled]="(add && !common.visibleChamp.persObj98.creation) || (!add && edit && !common.visibleChamp.persObj98.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj99  && common.visibleChamp.persObj99.visible">
              <label class="col-sm-3 champ" style="padding:0px"> URL Ecorec externe :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.URLEcorecExterne" 
                  [hidden]="!common.visibleChamp.persObj99.vision"
                  [disabled]="(add && !common.visibleChamp.persObj99.creation) || (!add && edit && !common.visibleChamp.persObj99.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj100  && common.visibleChamp.persObj100.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Num Carte Chrono. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="personnel.numCarteChrono" 
                  [hidden]="!common.visibleChamp.persObj100.vision"
                  [disabled]="(add && !common.visibleChamp.persObj100.creation) || (!add && edit && !common.visibleChamp.persObj100.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj101  && common.visibleChamp.persObj101.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Date Carte Chrono :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [activeDropUp]="true" [dateVide]="true" [class]="'form-control input-simple'"
                  [id]="'txtDate'" [model]="personnel.dateCarteChrono" [maxDate]="maxDate"
                  [closeDatepickerOnSelect]="true" (changefct)="changeDate($event, 'dateValiditeVisiteMedicale')"
                  [showDatepicker]="true" (changefct)="changeDate($event, 'dateCarteChrono')" 
                  *ngIf="common.visibleChamp.persObj101.vision"
                  [disable]="(add && !common.visibleChamp.persObj101.creation) || (!add && edit && !common.visibleChamp.persObj101.modifiable)"></app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj102  && common.visibleChamp.persObj102.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Login EDC2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" step="0.001" class="form-control" [(ngModel)]="personnel.loginEDC2" 
                  [hidden]="!common.visibleChamp.persObj102.vision"
                  [disabled]="(add && !common.visibleChamp.persObj102.creation) || (!add && edit && !common.visibleChamp.persObj102.modifiable)">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj103  && common.visibleChamp.persObj103.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Mot de passe EDC2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="password" class="form-control" [(ngModel)]="personnel.pwdEDC2" 
                  [hidden]="!common.visibleChamp.persObj103.vision"
                  [disabled]="(add && !common.visibleChamp.persObj103.creation) || (!add && edit && !common.visibleChamp.persObj103.modifiable)"
                  autocomplete="off">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Code EDC2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" step="1" class="form-control" [(ngModel)]="personnel.codeEDC2">
              </div>
            </div>
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj105  && common.visibleChamp.persObj105.visible">
              <label class="col-sm-3 champ" style="padding:0px"> Langue :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px" *ngIf='common.visibleChamp.persObj105.vision'
                [ngClass]="{'disabledbutton': (add && !common.visibleChamp.persObj105.creation) || (!add && edit && !common.visibleChamp.persObj105.modifiable)}">
                <app-autocomplete [placeholder]="''" (searchfunction)="searchLangue($event)"
                  (selectfunction)="setLangue($event)" [results]="listLangue" [highlight]="true" [label]="''"
                  [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'" [defaultselected]="personnel.langue"
                  [defaultsearch]="personnel.langue ? (personnel.langue.libelle || personnel.langue.libelleObjetEntite) : ''"></app-autocomplete>
              </div>
            </div>
            <!--div class="form-group items col-sm-12" *ngIf="personnel.langue && personnel.langue.id">
              <label class="col-sm-3 champ" style="padding:0px">Langue : </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                {{ personnel.langue ? personnel.langue.libelle || personnel.langue.libelleObjetEntite : '' }}
              </div>
            </div-->
            <div class="form-group items col-sm-12"
              *ngIf="common.visibleChamp &&  common.visibleChamp.persObj104  && common.visibleChamp.persObj104.visible">
              <label class="col-sm-3 champ" style="padding:0px"> EcoBM 2j :</label>
              <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px"
                *ngIf='common.visibleChamp.persObj104.vision'>
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.ecobm2J" (change)="onEcobm2JChange()"
                  [disabled]="(add && !common.visibleChamp.persObj104.creation) || (!add && edit && !common.visibleChamp.persObj104.modifiable)"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> EcoBM 4j :</label>
              <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.ecobm4J" (change)="onEcobm4JChange()"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Visible Ecodechet :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="personnel.visibleEcodechet">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Pont Bascule :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete [placeholder]="''" (searchfunction)="searchPont($event)"
                  (selectfunction)="setPont($event)" [results]="listPont" [highlight]="true" [label]="''"
                  [dropdownclass]="mindropdown" [id]="'modedepaie clientRefact'" [defaultselected]="personnel.pontBasculeChauffeur"
                  [defaultsearch]="personnel.pontBasculeChauffeur ? (personnel.pontBasculeChauffeur.codePont || personnel.pontBasculeChauffeur.libelleObjetEntite) : ''"></app-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Contrat" *ngIf="droitContrat">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;height: 100%;">
          <div class="col-sm-12 detail" style="height: 100%" (click)="common.outSide($event)">
            <div class="header col-sm-12">
              <div *ngIf="!personnel.interimaire" class="col-sm-6">
                <button class="btn-add" id="addLigne" (click)="addLigneContrat()">
                  <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigneContrat()">Ajouter une ligne</span>
              </div>
              <div class="text-right"
                [ngClass]="{'col-sm-12': personnel.interimaire, 'col-sm-6': !personnel.interimaire}">
                <h2> Liste des contrats </h2>
              </div>
            </div>
            <!--Si site.dechetterie checked-->
            <div class="col-sm-12 ligneBon liste contrat-personnel">
              <ngx-datatable style="height: 100%" class="material" [rows]="personnel.listeContrat"
                [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="35"
                [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [selected]="selected">
                <ngx-datatable-column prop="dateDebut">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Date début </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <app-input-date [activeDropUp]="true" *ngIf="row.editLigne" [dateVide]="true"
                      [class]="'form-control input-simple'" [id]="'txtDate'" [model]="row.start" [maxDate]="maxDate"
                      [closeDatepickerOnSelect]="true" [container]="true" [showDatepicker]="true"
                      (changefct)="changeDateContrat($event, 'dateDebutEdit', row)"></app-input-date>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="dateFin">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Date fin </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <app-input-date [activeDropUp]="true" *ngIf="row.editLigne" [dateVide]="true"
                      [class]="'form-control input-simple'" [id]="'txtDate'" [model]="row.end" [maxDate]="maxDate"
                      [closeDatepickerOnSelect]="true" [container]="true" [showDatepicker]="true"
                      (changefct)="changeDateContrat($event, 'dateFinEdit', row)"></app-input-date>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="qualification.libelleObjetEntite">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Qualification </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <app-autocomplete *ngIf="row.editLigne" [placeholder]="''" [container]="true" [disablefocus]="true"
                      (selectfunction)="row.qualificationEdit = $event" [results]="listeQualif" [isCombo]="true"
                      [highlight]="true" [label]="''" [dropdownclass]="mindropdown" [selectvalue]="true"
                      [id]="'modedepaie site'" [defaultselected]="row.qualificationEdit"
                      [defaultsearch]="(row.qualificationEdit ? (row.qualificationEdit.libelleObjectEntite || row.qualificationEdit.libelle || '') : '')">
                    </app-autocomplete>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="site.nom">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Site </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <app-autocomplete *ngIf="row.editLigne" [placeholder]="''" [container]="true" [disablefocus]="true"
                      (searchfunction)="searchSite($event)" (selectfunction)="row.siteEdit = $event"
                      [results]="listeSite" [highlight]="true" [label]="''" [dropdownclass]="mindropdown"
                      [selectvalue]="true" [id]="'modedepaie site'" [defaultselected]="row.siteEdit" [isCombo]="true"
                      [defaultsearch]="value || (row.siteEdit ? (row.siteEdit.libelleObjectEntite || row.siteEdit.nom) : '')">
                    </app-autocomplete>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="numContrat">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> N° Contrat </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>

                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <input type="text" class="form-control" [(ngModel)]="row.numContratEdit" *ngIf="row.editLigne" />
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column *ngIf="isCycleTravail" prop="cycleTravail.nom">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Cycle de travail </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{ value }} </div>
                    <app-autocomplete *ngIf="row.editLigne" [placeholder]="''" [container]="true" [disablefocus]="true"
                      (selectfunction)="row.cycleTravailEdit = $event" [results]="listCycleTravail" [highlight]="true"
                      [label]="''" [dropdownclass]="mindropdown" [selectvalue]="true" [id]="'modedepaie site'"
                      [defaultselected]="row.cycleTravailEdit" [isCombo]="true"
                      [defaultsearch]="(row.cycleTravailEdit ? (row.cycleTravailEdit.libelleObjectEntite || row.cycleTravailEdit.nom) : '')">
                    </app-autocomplete>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column *ngIf="isCycleTravail" prop="dateDebutCycleTravail">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Début Cycle travail </span>
                      <div class=" shorticone pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <app-input-date [activeDropUp]="true" *ngIf="row.editLigne" [dateVide]="true"
                      [class]="'form-control input-simple'" [id]="'txtDate'" [model]="row.startCycleTravail"
                      [maxDate]="maxDate" [closeDatepickerOnSelect]="true" [container]="true" [showDatepicker]="true"
                      (changefct)="changeDateContrat($event, 'dateDebutCycleTravailEdit', row)"></app-input-date>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                  [resizeable]="false">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                      <button class="btn-detail" *ngIf="!row.editLigne" (click)="modifLigneContrat(row);">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button class="btn-detail" *ngIf="!row.editLigne" (click)="deleteLigneContrat(row);">
                        <i class="fa fa-trash"></i>
                      </button>

                      <button class="btn-check" *ngIf="row.editLigne">
                        <i class="fa fa-check" aria-hidden="true" (click)="validerModif(row);"></i>
                      </button>
                      <button class="btn-closes" *ngIf="row.editLigne" (click)="revertModif(row)">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Documents">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;height: 100%;">
          <div class="col-sm-12 detail" style="height: 100%" (click)="common.outSide($event)">
            <div class="header col-sm-12">
              <div class="col-sm-6">
                <button class="btn-add" id="addLigneDocuments" (click)="addLigneDocument()">
                  <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigneDocument()">Ajouter un document</span>
              </div>
              <div class="text-right"
                [ngClass]="{'col-sm-12': personnel.interimaire, 'col-sm-6': !personnel.interimaire}">
                <h2> Fichiers </h2>
              </div>
            </div>
            <!--Si site.dechetterie checked-->
            <div class="col-sm-12 ligneBon liste">
              <ngx-datatable style="height: 100%" class="material" [rows]="documents" [columnMode]="'force'"
                [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: 'Pas de lignes à afficher'}">
                <ngx-datatable-column prop="nomFichierOriginal">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Fichier </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <div *ngIf="row.editLigne">
                      <input class="hide" id="input-file-id{{rowIndex}}" (change)="getNameFile($event, row)" multiple
                        type="file" accept="{{ common.extFichierImgEtTexte }}" />
                      <div class="input-group">
                        <input type="text" class="form-control" [(ngModel)]="row.nomFichier" readonly>
                        <label class="input-group-addon" for="input-file-id{{rowIndex}}"><i class="fa fa-upload"></i>
                          Parcourir </label>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="description">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Description </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne">{{value}}</div>
                    <div *ngIf="row.editLigne">
                      <input type="text" class="form-control" [(ngModel)]="row.description">
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="oTypeDocAssocie.libelle">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Type Doc </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{value}} </div>
                    <div *ngIf="row.editLigne">
                      <app-autocomplete (selectfunction)="row.oTypeDocAssocie = $event;" [container]="true"
                        [results]="typeDocuments" [highlight]="true" [isCombo]="true" id="typeDocuments"
                        [dropdownclass]="'dropdownDocType'" [defaultselected]="row.oTypeDocAssocie"
                        [defaultsearch]="row.oTypeDocAssocie ? row.oTypeDocAssocie.libelle : ''"></app-autocomplete>
                    </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                  [resizeable]="false">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                      <button class="btn-detail" *ngIf="!row.editLigne" (click)="deleteLigneDocument(row)">
                        <i class="fa fa-trash"></i>
                      </button>

                      <button class="btn-detail" *ngIf="!row.editLigne" (click)="imprimerDocChauffeur(row.id)">
                        <i class="fa fa-print"></i>
                      </button>

                      <button class="btn-check" *ngIf="row.editLigne">
                        <i class="fa fa-check" aria-hidden="true" (click)="ajouterDocument(row)"></i>
                      </button>
                      &nbsp;
                      <button class="btn-closes" *ngIf="row.editLigne" (click)="revertUpateDocument(row)">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Compteurs" *ngIf="isGestionCompteurRH">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;height: 100%;">
          <div class="col-sm-12 detail" style="height: 100%" (click)="common.outSide($event)">
            <div class="header col-sm-12">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">
                <h2> Liste des compteurs RH </h2>
              </div>
            </div>

            <div class="col-sm-12 ligneBon liste">
              <ngx-datatable style="height: 100%" class="material" [rows]="personnel.listCompteurRH"
                [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="35"
                [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [selected]="selected">
                <ngx-datatable-column>
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Compteur </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne"> {{ row.compteurRH.libelleObjetEntite }} </div>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column>
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Valeur </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" [disabled]="true" class="form-control text-right" [(ngModel)]="row.valeur" />
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Articles Import" *ngIf="common.isImportFichiersPesees">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;">
          <div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%"
            (click)="common.outSide($event)">
            <div class="header col-sm-12">
              <div class="col-sm-6">
                <button class="btn-add" id="addLigneCAP" (click)="addLigneArtImport()">
                  <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigneArtImport()">Ajouter une ligne</span>
              </div>
              <div class="col-sm-6 text-right">
                <h2> Liste des articles</h2>
              </div>
            </div>

            <div class="col-sm-12 ligneBon liste">
              <ngx-datatable style="height: 100%" class="material" [rows]="personnel['listeArticleImport'] || []"
                [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="35"
                [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [selected]="selected">
                <ngx-datatable-column prop="article.code">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Article </span>
                      <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div>
                      <app-autocomplete [placeholder]="row.article ? '' : 'Article'"
                        (searchfunction)="searchArticle($event)"
                        (selectfunction)="row.article = $event;common.focusElementTimeout('#codeExterne' + rowIndex);"
                        [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true" [results]="dataArticle"
                        [id]="classPresta + ' article' + rowIndex"
                        [defaultsearch]="(row.article ? row.article.libelleObjetEntite : '')" [autohide]="true"
                        [dropdownclass]="'dropetat'" (keyenterfunction)="common.focusNext('.ligneBon')">
                      </app-autocomplete>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column prop="libelle">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> libellé </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne">{{value}}</div>
                    <input type="text" *ngIf="row.editLigne" class="input form-control detailfact" id="description{{rowIndex}}"
                      [(ngModel)]="row.libelle" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                  </ng-template>
                </ngx-datatable-column> -->
                <ngx-datatable-column prop="codeExterne">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">

                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> code externe </span>
                      <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control detailfact" id="codeExterne{{rowIndex}}"
                      [(ngModel)]="row.codeExterne" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                  [resizeable]="false">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">

                      <button class="btn-detail" (click)="deleteLigneArtImport(row);">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>

    <ngb-tab title="Exutoires import" *ngIf="common.isImportFichiersPesees">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;">
          <div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%"
            (click)="common.outSide($event)">
            <div class="header col-sm-12">
              <div class="col-sm-6">
                <button class="btn-add" id="addLigneCAP" (click)="addLigneExuImport()">
                  <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigneExuImport()">Ajouter une ligne</span>
              </div>
              <div class="col-sm-6 text-right">
                <h2> Liste des exutoires</h2>
              </div>
            </div>

            <div class="col-sm-12 ligneBon liste">
              <ngx-datatable style="height: 100%" class="material" [rows]="personnel['listeExutoireImport'] || []"
                [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="35"
                [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [selected]="selected">
                <ngx-datatable-column prop="exutoire.nom">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Exutoire </span>
                      <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div>
                      <app-autocomplete [placeholder]="row.exutoire ? '' : 'Exutoire'"
                        (searchfunction)="searchExutoireImp($event)"
                        (selectfunction)="row.exutoire = $event; row.exutoire.nom = row.exutoire.libelleObjetEntite; common.focusElementTimeout('#codeExterne' + rowIndex);"
                        [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true" [results]="dataExutoire"
                        [id]="classPresta + ' exutoire' + rowIndex"
                        [defaultsearch]="(row.exutoire ? (row.exutoire.nom || row.exutoire.libelleObjetEntite) : '')"
                        [autohide]="true" [dropdownclass]="'dropetat'"
                        (keyenterfunction)="common.focusNext('.ligneBon')">
                      </app-autocomplete>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column prop="libelle">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> libellé </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne">{{value}}</div>
                    <input type="text" *ngIf="row.editLigne" class="input form-control detailfact" id="description{{rowIndex}}"
                      [(ngModel)]="row.libelle" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                  </ng-template>
                </ngx-datatable-column> -->
                <ngx-datatable-column prop="codeExterne">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> code externe </span>
                      <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control detailfact" id="codeExterne{{rowIndex}}"
                      [(ngModel)]="row.codeExterne" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                  [resizeable]="false">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">

                      <button class="btn-detail" (click)="deleteLigneExuImport(row);">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
    <ngb-tab title="Zone de provenance" *ngIf="common.isImportFichiersPesees">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;">
          <div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%"
            (click)="common.outSide($event)">
            <div class="header col-sm-12">
              <div class="col-sm-6">
                <button class="btn-add" id="addLigneCAP" (click)="addLigneZoneImport()">
                  <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigneZoneImport()">Ajouter une ligne</span>
              </div>
              <div class="col-sm-6 text-right">
                <h2> Liste des zones de provenance</h2>
              </div>
            </div>

            <div class="col-sm-12 ligneBon liste">
              <ngx-datatable style="height: 100%" class="material" [rows]="personnel['listeZoneProvenanceImport'] || []"
                [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="35"
                [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [selected]="selected">
                <ngx-datatable-column prop="zone.libelleObjetEntite">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> Zone de provenance </span>
                      <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div>
                      <app-autocomplete [placeholder]="row.zone ? '' : 'Zone Provenance'"
                        (searchfunction)="searchZoneProvenance($event)"
                        (selectfunction)="row.zone = $event;row.zone.nom=row.zone.libelleObjetEntite;common.focusElementTimeout('#codeExterne' + rowIndex);"
                        [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true"
                        [results]="resultZoneProvenance" [id]="classPresta + ' zoneProvenance' + rowIndex"
                        [defaultsearch]="(row.zone ? (row.zone.libelleObjetEntite || row.zone.nom) : '')"
                        [autohide]="true" [dropdownclass]="'dropetat'"
                        (keyenterfunction)="common.focusNext('.ligneBon')">
                      </app-autocomplete>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column prop="libelle">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> libellé </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.editLigne">{{value}}</div>
                    <input type="text" *ngIf="row.editLigne" class="input form-control detailfact" id="description{{rowIndex}}"
                      [(ngModel)]="row.libelle" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                  </ng-template>
                </ngx-datatable-column> -->
                <ngx-datatable-column prop="codeExterne">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                      <span class="uppercase"> code externe </span>
                      <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>

                    <input type="text" class="input form-control detailfact" id="codeExterne{{rowIndex}}"
                      [(ngModel)]="row.codeExterne" autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                  [resizeable]="false">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                      <!-- <button class="btn-detail" (click)="saveArtImport(row);" *ngIf="row.editLigne">
                        <i class="fa fa-check"></i>
                      </button>
                      <button class="btn-detail" *ngIf="!row.editLigne" (click)="modifLigneArtImport(row);">
                        <i class="fa fa-pencil"></i>
                      </button> -->
                      <button class="btn-detail" (click)="deleteLigneZoneImport(row);">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
  </ngb-tabset>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>

<ng-template #popTemplateUser>
  <span [style.background]="personnel.couleur" [cpToggle]="true" [cpDialogDisplay]="'inline'"
    [(colorPicker)]="personnel.couleur" (colorPickerChange)="colorPickerChange()"></span>
</ng-template>

<ng-template #supprimerDocumentConfirme>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      Voulez-vous vraiment supprimer ce document ?
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="supprimerDocument(); common.closeModal();"> OUI
      </button>
      <button type="button" class=" btn-close" (click)="documentSelected = null; common.closeModal()">
        NON
      </button>
    </div>
  </div>
</ng-template>


<ng-template #JoursTravaille>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Semaine </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      Choix du jours de la semaine
    </div>

    <div class="btn-group col-sm-12 mt-1" role="toolbar">
      <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
        (click)="checkDayWeek(personnel.listJourSemaine,semaine.id)"
        [ngClass]="{'btn-primary': selectedSemaine(personnel.listJourSemaine,semaine.id)}">
        {{ semaine.libelleObjetEntite }}</div>
    </div>

    <div class="text-right" style="margin-top: 15px;padding-top: 52px">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();"> Fermer
      </button>
    </div>
  </div>
</ng-template>

<div *ngIf="isPrestationAssociees" style="height: 100%;">
  <div class="header">
    <div class="col-sm-8" style="padding: 0 15px;">
      <h2> Prestations Associées </h2>
    </div>
    <div class="col-sm-4 text-right" style="padding-right: 0;">
      <button class="btn-header uppercase" (click)="showPrestationAssociees()" id="close2"> Fermer </button>
      <button class="btn-header uppercase actionPricipal" id="valide2" (click)="savePrestationAssociees()">
        Valider </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="col-sm-12 detail paramsociete " *ngIf="!isEmpty && !isEdit"
    style="height: calc(100% - 50px); padding: 5px 0px;" (click)="common.outSide($event)">
    <div class="header col-sm-12">
      <div class="col-sm-6">
        <button class="btn-add" id="addLigne" (click)="addPrestationAssociees()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addPrestationAssociees()">Ajouter une ligne</span>
      </div>
    </div>

    <div class="col-sm-12 ligneBon liste" style="height: calc(100% - 40px);    padding: 0;">
      <ngx-datatable style="height: 100%" class="material" [rows]="listePrestationAssociees" [columnMode]="'force'"
        [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
        [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
        [selected]="selected">
        <ngx-datatable-column prop="code">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Article </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div>
              <div class="strong" *ngIf="!row.edit">
                {{value}}
              </div>
              <app-autocomplete *ngIf="row.edit" [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                (selectfunction)="setLibellePrestationAssocie($event, rowIndex)" [notOblig]="true" [label]="''"
                [selectvalue]="true" [container]="true" [results]="dataArticle" [id]="'article' + rowIndex"
                [defaultsearch]="(row ? row.libelleObjetEntite : '')" [autohide]="true" [dropdownclass]="'dropetat'"
                (keyenterfunction)="common.focusNext('.ligneBon')">
              </app-autocomplete>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="libelle">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> libellé </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div>{{value}}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-center">
              <div class="text-right" style="padding-right: 5px;">
                <button *ngIf="!row.edit" class="btn-detail" (click)="row.edit = !row.edit; showInput(rowIndex)">
                  <i class="fa fa-pencil"></i>
                </button>
                <button *ngIf="row.edit" class="btn-detail save" (click)="row.edit = !row.edit;">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </button>
                <button *ngIf="row.edit" class="btn-detail cancel" (click)="deletePrestationAssociees(row)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</div>

<div *ngIf="isFiliereDepartement" style="height: 100%;">
  <div class="header">
    <div class="col-sm-8" style="padding: 0 15px;">
      <h2> Filière/Département </h2>
    </div>
    <div class="col-sm-4 text-right" style="padding-right: 0;">
      <button class="btn-header uppercase" (click)="showFiliereDepartement()" id="close2"> Fermer </button>
      <button class="btn-header uppercase actionPricipal" id="valide2" (click)="saveFiliereDepartement()">
        Valider </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="col-sm-12 detail paramsociete " *ngIf="!isEmpty && !isEdit"
    style="height: calc(100% - 50px); padding: 5px 0px;" (click)="common.outSide($event)">
    <div class="header col-sm-12">
      <div class="col-sm-6">
        <button class="btn-add" id="addLigne" (click)="addFiliereDepartement()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addFiliereDepartement()">Ajouter une ligne</span>
      </div>
    </div>

    <div class="col-sm-12 ligneBon liste" style="height: calc(100% - 40px);    padding: 0;">
      <ngx-datatable style="height: 100%" class="material" [rows]="listeFiliereDepartement" [columnMode]="'force'"
        [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
        [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
        [selected]="selected">
        <ngx-datatable-column prop="libelle">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Filière </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div>
              <div class="strong" *ngIf="!row.edit">
                {{row.libelle || row.libelleObjetEntite}}
              </div>
              <app-autocomplete *ngIf="row.edit" (searchfunction)="searchFiliereDepartement($event)"
                (selectfunction)="setFiliereDepartement($event, rowIndex)" [results]="listFiliereFact"
                [highlight]="true" [id]="'filiereFact' + rowIndex" [isCombo]="true" [defaultselected]="row"
                [disablefocus]="true" [defaultsearch]="row ? row.libelle || row.libelleObjetEntite  : ''"
                [container]="true">
              </app-autocomplete>

            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="departement">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Département </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div class="strong" *ngIf="!row.edit">
              {{value}}
            </div>
            <input *ngIf="row.edit" id="departement{{rowIndex}}" type="text" class="form-control"
              [(ngModel)]="row.departement">
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-center">
              <div class="text-right" style="padding-right: 5px;">
                <button *ngIf="!row.edit" class="btn-detail" (click)="row.edit = !row.edit; showInput(rowIndex)">
                  <i class="fa fa-pencil"></i>
                </button>
                <button *ngIf="row.edit" class="btn-detail save" (click)="row.edit = !row.edit;">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </button>
                <button *ngIf="row.edit" class="btn-detail cancel" (click)="deleteFiliereDepartement(row)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</div>